export default "__VITE_ASSET__f347ecc5__"